export default {
  namespaced: true,
  custom_timezones: {
    title: "Timezone personalizado",
    name: "Nombre",
    start: "Inicio",
    end: "Fin",
    month: "Mes",
    day: "Día",
    week: "Semana",
    dts: "Horario de verano"
  },
};
